import React from 'react';
import { KEY_VISUALS } from './keyVisuals';
import { KeyRoleIcon } from './KeyBadge';
import styles from './styles/Keys.module.css';

const ROLES = ['grant', 'remove', 'has', 'lacks'];

/**
 * What the key markings on the canvas mean. Drawn from the same constants the
 * canvas uses, so it cannot drift from what it describes.
 */
const KeyLegend = () => (
    <ul className={styles.legend}>
        {ROLES.map((role) => {
            const visual = KEY_VISUALS[role];
            return (
                <li key={role} className={styles.legendRow}>
                    <span className={styles.legendMarks}>
                        <KeyRoleIcon role={role} size={12} />
                        <svg width="32" height="6" aria-hidden="true">
                            {!visual.dash ? (
                                <circle cx="16" cy="3" r="3" fill={visual.color} />
                            ) : (
                                <line
                                    x1="0"
                                    y1="3"
                                    x2="32"
                                    y2="3"
                                    stroke={visual.color}
                                    strokeWidth="2"
                                    strokeDasharray={visual.dash || undefined}
                                />
                            )}
                        </svg>
                    </span>
                    <span>{visual.label}</span>
                </li>
            );
        })}
    </ul>
);

export default KeyLegend;
